// extracted by mini-css-extract-plugin
export default {"filterIcon":"FilterButton_filterIcon__brXfE"};